import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalModule as BasePortalModule } from '@angular/cdk/portal';
import { PortalComponent } from './portal.component';
@NgModule({
  declarations: [PortalComponent],
  imports: [CommonModule, BasePortalModule],
  exports: [PortalComponent],
})
export class PortalModule {}
